import React from 'react';

interface SummaryInfoListProps {
	items: {
		label: string;
		value: string | number | React.ReactNode | undefined;
	}[];
	noBg?: boolean;
}

const SummaryInfoList: React.FC<SummaryInfoListProps> = ({ items, noBg }) => {
	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
				gap: '1rem',
			}}
		>
			{items.map((item, index) => (
				<div
					key={item.label}
					style={{
						backgroundColor: index > 5 || noBg ? 'initial' : '#edf0f7',
						padding: '1rem',
						borderRadius: '8px',
						display: 'flex',
						flexDirection: 'column',
						gap: '10px',
						overflow: 'hidden',
					}}
				>
					<div
						style={{
							fontSize: '16px',
							fontWeight: 700,
						}}
					>
						{item.label}
					</div>
					<div
						style={{
							overflowWrap: 'break-word',
							wordBreak: 'break-word',
							whiteSpace: 'normal',
						}}
					>
						{item.value ?? 'N.D.'}
					</div>
				</div>
			))}
		</div>
	);
};

export default SummaryInfoList;
